import { getNoticeDetail } from "@/api/notice";

export default {
  namespaced: true,
  state: {
    noticeInfo: {
      authToken:  "",
      noticeCode:  "",
      organizationCode:  "",
      departmentCode:  "",
      noticeTitle:  "",
      noticeContent:  "",
      noticeFile:  "",
      noticeFileName:  "",
      createdAt:  "",
      updateAt:  "",
      userCode:  "",
      userName:  "",
    },
    noticeViewData: {},
  },
  mutations: {
    setNoticeInfo(state, payload) {
      state.noticeInfo = {
        noticeCode : payload.noticeCode || "",
        noticeTitle : payload.noticeTitle ||  "",
        noticeContent : payload.noticeContent ||  "",
        memberCode : payload.memberCode ||  "",
        updateAt : payload.updateAt ||  "",
        no : payload.no ||  "",
        memberName : payload.memberName ||  "", 
        file : payload.file ||  "",
        filePreview : payload.file || "",
        imgeName : payload.imgeName || "",
        fileNm : payload.fileNm || "",
        pinnedOrder : payload.pinnedOrder || "",
      };
    },
    clearNoticeInfo(state) {
      state.noticeInfo = {
        noticeCode : "",
        noticeTitle : "",
        noticeContent : "",
        memberCode : "",
        updateAt : "",
        no : "",
        memberName : "", 
        file : "",
        filePreview : "",
        imgeName : "",
        fileNm : "",
        pinnedOrder : "",  
      };
    },
    setNoticeViewData(state, payload) {
      state.noticeViewData = payload;
    },
    clearNoticeViewData(state) {
      state.noticeViewData = {};
    },
  },
  actions: {
    async fetchNoticeView({ commit }, payload) {
      commit("clearNoticeViewData");
      let rtn = {};
      rtn = await getNoticeDetail(payload);

      commit("setNoticeViewData", rtn?.data);
    },
  },
};
